import { Component, OnInit } from '@angular/core';
import {ContenServiceService} from '../api/conten-service.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
   activeLink ;
  constructor(private contentServicice: ContenServiceService) { }

  ngOnInit() {
    this.contentServicice.currentActive.subscribe(
      currentActiveLink => {this.activeLink = currentActiveLink; }
    );
  }
  linkSelectd(link: string) {
    this.contentServicice.LinkClick.next(link);
  }

}
